import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Scoring icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Scoring } from '@sravni/design-system-icons'
 *
 * <Scoring />
 * ```
 */
var Scoring = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Scoring", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.683 17.555C1.081 13.67 1.496 8.362 4.929 4.93c3.905-3.905 10.237-3.905 14.142 0 3.433 3.433 3.848 8.74 1.246 12.626", stroke: "currentColor", strokeWidth: "1.538", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M13.571 10.429a2.222 2.222 0 1 1-3.142 3.142 2.222 2.222 0 0 1 3.142-3.142M12 2v2.222M17 3.344l-.967 1.667M7 3.344l.967 1.667M3.344 7l1.667.967M22 12h-1.667M3.667 12H2M13.989 11.033 20.656 7", stroke: "currentColor", strokeWidth: "1.538", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Scoring };
//# sourceMappingURL=Scoring.js.map
